import { Directive } from '@angular/core';
import { TUI_TOGGLE_DEFAULT_OPTIONS, TUI_TOGGLE_OPTIONS } from '@taiga-ui/kit';

@Directive({
  selector: '[appLocaleToggle]',
  providers: [
    {
      provide: TUI_TOGGLE_OPTIONS,
      useValue: {
        ...TUI_TOGGLE_DEFAULT_OPTIONS,
        icons: {
          toggleOff: 'eng',
          toggleOn: 'rus'
        },
        singleColor: true,
        showIcons: true,
        size: 'l'
      }
    }
  ]
})
export class LocaleToggleDirective {}
